<template>
  <div>
    <div class="isTxt" v-if="isTxt">
      {{ !isNullOrUndefOrEmpty(name) ? name + (data.unit || '元') : '-' }}
    </div>
    <RxkInput
      v-else
      style="width: 100%"
      :model-value="innerValue"
      :maxlength="data.maxLength || renderConfig.maxlength"
      type="text"
      :disabled="renderConfig.disabled"
      :placeholder="renderConfig.placeholder"
      @update:modalValue="handleInput"
      @blur="handleBlur"
    >
      <template #suffix>
        <span>{{ data.unit }}</span>
      </template>
    </RxkInput>
    <div v-if="uppercase">
      {{ innerValue ? numToCapital(dealUpper) : '' }}
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, watch, unref, watchEffect, onMounted } from 'vue'
import { basicProps } from '@/components/custom/form/components/props'
import { RxkInput } from '@/components/common/RxkInput'
import { numToCapital } from '@/utils/tools'
import { isEmpty, isNullOrUndefOrEmpty } from '@/utils/is'
import { getAssociatedData } from '@/components/custom/form/components/utils'
import { useDealAssociatedData } from '@/hooks/useDealAssociatedData'

const props = defineProps({
  ...basicProps
})
const emit = defineEmits(['update:modelValue', 'refreshDataList', 'blur'])

const innerValue = computed({
  get() {
    return props.modelValue
  },
  set(newVal) {
    emit('update:modelValue', newVal)
  }
})
const millage = computed(() => {
  const setting = props.data.setting
    ? !isEmpty(JSON.parse(props.data.setting))
      ? JSON.parse(props.data.setting)
      : { web: {} }
    : { web: {} }
  return setting.web.millage || false
})
const uppercase = computed(() => {
  const setting = props.data.setting
    ? !isEmpty(JSON.parse(props.data.setting))
      ? JSON.parse(props.data.setting)
      : { web: {} }
    : { web: {} }
  return setting.web.uppercase || false
})
const dealUpper = computed(() => {
  let val = reset(unref(innerValue))
  console.log(props.data, 'props.data233')
  switch (props.data.unit) {
    case '万':
      return val * 10000
    case '千万':
      return val * 10000 * 1000
    case '角':
      return val * 0.1
    case '分':
      return val * 0.01
  }
  console.log(reset(val), 'reset(val)777')
  return reset(val)
})
const name = computed(() => {
  handleInput(innerValue.value)
  return innerValue.value
})

watchEffect(() => handleInput(innerValue.value))

function reset(value: number) {
  return Number(String(value).replace(/,/g, '')) // 如果是小数用parseFloat
}

function handleInput(val: any) {
  let temp = val?.toString() || ''
  temp = temp.replace(/[^\d.]/g, '') // 清除"数字"和"."以外的字符
  temp = temp.replace(/^\./g, '') // 验证第一个字符是数字
  temp = temp.replace(/\.{2,}/g, '.') // 只保留第一个, 清除多余的
  // 处理小数点位数
  if (props?.data?.precisions) {
    const decimal = temp.split('.')[1]
    const integer = temp.split('.')[0]
    if (decimal) {
      temp = integer + '.' + decimal.substring(0, props.data.precisions)
    }
  } else {
    temp = temp.replace(/[^\d]/g, '')
  }
  // 添加千分位
  if (millage.value) {
    if (temp.indexOf('.') > -1) {
      const arr = temp.split('.')
      temp = arr[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + arr[1]
    } else {
      temp = temp.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  }
  innerValue.value = temp
}

onMounted(() => {
  if (props.modelValue) {
    handleInput(props.modelValue)
  }
})

function handleBlur() {
  emit('blur', innerValue.value)
}

// 回显值获取函数(关联已有数据)
const getFetchAssociatedData = () => {
  return getAssociatedData(props).then((res: Recordable) => {
    innerValue.value = res?.value || ''
    return res
  })
}

watch(
  // 避免新值和旧值一样的情况(监听"引用类型")
  () => JSON.parse(JSON.stringify(props.formData)),
  (newFormData, oldFormData) => {
    useDealAssociatedData(props, oldFormData, getFetchAssociatedData)
  },
  { immediate: true, deep: true }
)
</script>
